import {Axios} from '@asocial/fe-utils'
import axios, {AxiosResponse} from 'axios'
import {ErrorResponsesType} from 'shared/types'

export type UploadMediaType = 'attachment' | 'avatar' | 'public' | 'private' | 'banner'

type GetDirectUploadUrlParams = {count?: number, mediaType?: UploadMediaType}
type VideoDirectType = {cfId: string, uploadUrl: string}
type PhotoDirectType = {key: string, uploadUrl: string}
export type GetDirectUploadUrlVideoResponse = VideoDirectType[]
export type GetDirectUploadUrlPhotoResponse = PhotoDirectType[]
type CFResponse = {
  result: {
    id: string,
    filename: string,
    uploaded: string,
    requireSignedURLs: boolean,
    variants: Array<string>
  },
  success: boolean,
  errors: Array<string>,
  messages: Array<string>
}

export const GetDirectUploadUrlPhoto = (params: GetDirectUploadUrlParams): Promise<AxiosResponse<GetDirectUploadUrlPhotoResponse, any>> =>
  Axios.post(`upload/photos/direct`, {count: params.count, type: params.mediaType})

export const GetDirectUploadUrlVideo = (params: GetDirectUploadUrlParams): Promise<AxiosResponse<GetDirectUploadUrlVideoResponse, any>> =>
  Axios.post(`upload/videos/direct`, {count: params.count, type: params.mediaType})

export const uploadMediaToCF = (url: string, data: FormData): Promise<AxiosResponse<CFResponse, any>> =>
  axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}})

export const UploadMediaToBucket = (url: string, data: File): Promise<AxiosResponse<null, any>> =>
  axios.put(url, data, {headers: {'Content-Type': data.type}})

export const checkVideoUpload = (cfId: string): Promise<AxiosResponse<{ready: boolean}, any>> =>
  Axios.get(`/upload/videos/${cfId}/status`)

export const DeletePhotos = (ids: string[]): Promise<AxiosResponse<null, ErrorResponsesType>> =>
  Axios.delete(`/photos`, {data: {ids}})